import { UserGroup } from 'types/graphql'

import StaffUserGroupSelect from 'src/components/Selects/StaffUserGroupSelect'

import { TanstackField } from '../../../utils/forms'

type Props<TKey extends string> = {
  caption?: string
  field: TanstackField<UserGroup | undefined, TKey>
  isRequired?: boolean
  label?: string
}

const StaffUserGroupSelectField = <TKey extends string>({
  caption,
  field,
  isRequired,
  label,
}: Props<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')
  const isInvalid = !!errorMessage
  return (
    <StaffUserGroupSelect
      caption={caption}
      errorMessage={errorMessage}
      isInvalid={isInvalid}
      isRequired={isRequired}
      label={label}
      onBlur={field.handleBlur}
      onValueChange={field.setValue}
      value={field.state.value}
    />
  )
}

export default StaffUserGroupSelectField
